import { SyntheticListenerMap } from "@dnd-kit/core/dist/hooks/utilities";

import { TLesson } from "../../../../../@types";
import { useMyCourseInstructor } from "../../hooks/useMyCourseInstructor";
import { LessonItemDetail } from "./LessonItemDetail";
import { LessonItemHeader } from "./LessonItemHeader";

export type TMyCourseLessonProps = {
	lesson: TLesson;
	isDragging: boolean;
	setNodeRef: (node: HTMLElement | null) => void;
	pointerListeners: SyntheticListenerMap | undefined;
};

export function MyCourseLesson({
	lesson,
	isDragging,
	setNodeRef,
	pointerListeners,
}: TMyCourseLessonProps) {
	const { openingLessons, toggleOpenLesson } = useMyCourseInstructor();
	const expand = openingLessons.has(lesson.id);
	const setExpand = (open: boolean) => {
		toggleOpenLesson(lesson.id, open);
	};

	return (
		<div className="lesson-container">
			<LessonItemHeader
				lesson={lesson}
				expand={expand}
				setExpand={setExpand}
				isDragging={isDragging}
				setNodeRef={setNodeRef}
				pointerListeners={pointerListeners}
			/>
			{expand && !isDragging && <LessonItemDetail lesson={lesson} />}
		</div>
	);
}
